<template>
  <div class="home-rrisk-mian">
    <div class="home-rrisk-left" ref="rriskLeftId">
      <HomeChartBlock refId="Highcharts2" v-if="offsetWidth && offsetWidth > 0" :option="option"></HomeChartBlock>
    </div>
    <div class="home-rrisk-right">
      <div class="rrisk-right-item">
        <div class="right-item-msg">
          <i></i>
          <span>重大风险</span>
        </div>

        <div class="right-item-content">
          <span>{{ newData.riskClassificationCount && newData.riskClassificationCount != '' ? newData.riskClassificationCount : "0"
          }}</span>
          <label>个</label>
        </div>
      </div>


      <div class="rrisk-right-item color-2">
        <div class="right-item-msg">
          <i></i>
          <span>较大风险</span>
        </div>

        <div class="right-item-content">
          <span>{{ newData.riskClassificationCount1 && newData.riskClassificationCount1 != '' ? newData.riskClassificationCount1 :
            "0" }}</span>
          <label>个</label>
        </div>
      </div>

      <div class="rrisk-right-item color-3">
        <div class="right-item-msg">
          <i></i>
          <span>一般风险</span>
        </div>

        <div class="right-item-content">
          <span>{{ newData.riskClassificationCount2 && newData.riskClassificationCount2 != '' ? newData.riskClassificationCount2 :
            "0" }}</span>
          <label>个</label>
        </div>
      </div>


      <div class="rrisk-right-item color-4">
        <div class="right-item-msg">
          <i></i>
          <span>低风险</span>
        </div>

        <div class="right-item-content">
          <span>{{ newData.riskClassificationCount3 && newData.riskClassificationCount3 != '' ? newData.riskClassificationCount3 :
            "0" }}</span>
          <label>个</label>
        </div>
      </div>


    </div>
    {{ showData }}
  </div>
</template>

<script>
import { set } from 'vue'
import HomeChartBlock from './HomeChartBlock'
import { parseNumber } from '@/utils'
export default {
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  components: {
    HomeChartBlock
  },
  data() {
    return {
      offsetWidth: 0,
      newData: { 
      }
    }
  },
  computed: {
    showData() {
      this.newData = JSON.parse(JSON.stringify(this.item))
      this.newData.riskClassificationCount = 0
      this.newData.riskClassificationCount1 = 0
      this.newData.riskClassificationCount2 = 0
      this.newData.riskClassificationCount3 = 0
      return ''
    },
    option() {
      let _this = this
      let dataOld = {
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        chart: {
          type: "pie", //饼图
          spacingTop: 0,
          spacingLeft: 0,
          spacingRight: 0,
          spacingBottom: 0,
          marginBottom: 0,//设置下边距 
          marginLeft: 0,//设置左边距 
          marginRight: 0,//设置右边距 
          marginTop: 0, //设置上边距 
          margin: 0,
          options3d: {
            enabled: true, //使用3d功能
            alpha: 60, //延y轴向内的倾斜角度
            beta: 0,
          },
          backgroundColor: "rgba(0, 0, 0, 0)", // 不显示背景色 
          height: 280, //设置大小是为了饼图能在想要的区域中显示
        },
        legend: {
          enabled: false,
          bottom: "0%",
          itemStyle: {
            //图例文字的样式
            color: "#999",
            fontSize: 10,
          },
          left: "center",
          itemWidth: 100,
          // doesn't perfectly work with our tricks, disable it
          selectedMode: false,
          data: [],
        },
        title: {
          text: "", //图表的标题文字
        },
        subtitle: {
          text: "", //副标题文字 
        },
        tooltip: {
          shared: true,
          valueSuffix: '',
          backgroundColor: {
            linearGradient: [0, 0, 0, 60],
            stops: [
              [0, '#17317F'],
              [1, '#17317F']
            ]
          },
          borderWidth: 1,
          borderColor: '#00D361',
          shadow: true,
          padding: 10,
          formatter: function (data) {
            let str =
              '<div style="width: 100%;display: block;">'
              + '<div style="width: 100%;display: block;font-size: 11px;color: #ffffff;font-weight: 400;">' + this.key + '-比例</div>'
              + '</br>'
              + '<div style="width: 100%;display: block;font-size: 27px;color: ' + this.color + ';font-weight: bold;">' + this.y + '%</div>'
              + '</div>'
            return str
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true, //每个扇块能否选中
            cursor: "pointer", //鼠标指针
            size: _this.offsetWidth > 0 && _this.offsetWidth <= 350 ? _this.offsetWidth > 0 && _this.offsetWidth <= 280 ? 110 : 150 : 220,
            showInLegend: true, // 是否显示图例
            depth: _this.offsetWidth > 0 && _this.offsetWidth <= 350 ? _this.offsetWidth > 0 && _this.offsetWidth <= 280 ? 80 : 100 : 120, //饼图的厚度
            dataLabels: {
              enabled: true, //是否显示饼图的线形tip
              distance: 10, //设置引导线的长度
              color: "#fff", //全局设置字体颜色
              style: {
                textOutline: "none", //去掉文字白边
                fontSize: "18",
              },
              formatter: function () {
                return this.y + "%";
              },
            },
          },
        },
        credits: {
          enabled: false, //禁用版权url    此处不设置
        },
        series: [
          {
            type: "pie",
            name: "", //统一的前置词,非必须
            data: [
              { name: "重大风险", y: this.item.riskClassificationRatio && !isNaN(Number(this.item.riskClassificationRatio)) ? parseNumber(Number(this.item.riskClassificationRatio) * 100) : 0, color: "#cf0202" },
              { name: "较大风险", y: this.item.riskClassificationRatio1 && !isNaN(Number(this.item.riskClassificationRatio1)) ? parseNumber(Number(this.item.riskClassificationRatio1) * 100) : 0, color: "#ff7301" },
              { name: "一般风险", y: this.item.riskClassificationRatio2 && !isNaN(Number(this.item.riskClassificationRatio2)) ? parseNumber(Number(this.item.riskClassificationRatio2) * 100) : 0, color: "#f4fc00" },
              { name: "低风险", y: this.item.riskClassificationRatio3 && !isNaN(Number(this.item.riskClassificationRatio3)) ? parseNumber(Number(this.item.riskClassificationRatio3) * 100) : 0, color: "#00B2FC" },
            ],
            startAngle: 0, //调整饼图的角度   方向：顺时针 
            label: {
              enabled: false, //禁用版权url    此处不设置
              show: false,
              position: "outside",
              formatter: "{b}：{d}%",
              normal: {
                enabled: false, //禁用版权url    此处不设置
                show: false,
                fontSize: 14,
                formatter: ["  {a|{b}：{d}%}"].join("\n"), //用\n来换行
                rich: {
                  a: {
                    left: 20,
                    padding: [0, -140, 0, -180], //位置按需要调整
                  },
                },
              },
            },
          },
        ],
      }
      return dataOld
    }
  },

  created() {
    let _this = this
    window.addEventListener('resize', () => { //监听浏览器大小去改变图表尺寸 
      _this.calculateWidth()
    })

    setTimeout(() => {
      _this.calculateWidth()
    }, 300)

    setInterval(() => {
      this.newData.riskClassificationCount = this.trendsHandle(this.newData.riskClassificationCount, this.item.riskClassificationCount)
      this.newData.riskClassificationCount1 = this.trendsHandle(this.newData.riskClassificationCount1, this.item.riskClassificationCount1)
      this.newData.riskClassificationCount2 = this.trendsHandle(this.newData.riskClassificationCount2, this.item.riskClassificationCount2)
      this.newData.riskClassificationCount3 = this.trendsHandle(this.newData.riskClassificationCount3, this.item.riskClassificationCount3)
    }, 50);
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    calculateWidth() {
      let _this = this
      if (_this.$refs['rriskLeftId']) {
        _this.offsetWidth = _this.$refs['rriskLeftId'].offsetWidth
      } else {
        setTimeout(() => {
          if (_this.$refs['rriskLeftId']) {
            _this.offsetWidth = _this.$refs['rriskLeftId'].offsetWidth
          } else {
            setTimeout(() => {
              if (_this.$refs['rriskLeftId']) {
                _this.offsetWidth = _this.$refs['rriskLeftId'].offsetWidth
              }
            }, 1000)
          }
        }, 500)
      }
    },
    // 动态处理
    trendsHandle(currentRate, rate) {
      if (!rate || rate == '' || isNaN(Number(rate))) {
        return '0'
      }
      rate = parseNumber(Number(rate))

      if (isNaN(Number(currentRate))) {
        currentRate = 0;
      } else {
        currentRate = parseNumber(Number(currentRate));
      }

      if (currentRate < rate) {
        if (parseInt(rate) == currentRate) {
          currentRate = parseNumber(currentRate + (rate - parseInt(rate)));
        } else {
          currentRate = parseNumber(currentRate + 1);
        }

        return currentRate
      } else {
        return rate
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-rrisk-mian {
  width: 100%;
  height: 282px;
  display: flex;
  justify-content: center;
  align-items: center;

  .home-rrisk-left {
    z-index: 77;
    width: 65%;
    height: 100%;
    display: block;
  }

  .home-rrisk-right {
    width: 35%;
    margin-left: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: wrap;
    padding-top: 30px;

    .rrisk-right-item {
      width: 50%;
      padding: 20px 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-flow: column;

      .right-item-msg {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          width: 7px;
          height: 7px;
          background: #cf0202;
          border-radius: 50%;
          margin-right: 7px;
        }

        span {
          font-size: 11px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 100%;
        }
      }


      .right-item-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: 12px;

        span {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #cf0202;
          line-height: 100%;
        }

        label {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #cf0202;
          margin-left: 3px;
          line-height: 100%;
          padding-bottom: 2px;
        }
      }
    }




    .color-2 {
      .right-item-msg {
        i {
          background: #ff7301;
        }
      }

      .right-item-content {
        span {
          color: #ff7301;
        }

        label {
          color: #ff7301;
        }
      }
    }

    .color-3 {
      .right-item-msg {
        i {
          background: #f4fc00;
        }
      }

      .right-item-content {
        span {
          color: #f4fc00;
        }

        label {
          color: #f4fc00;
        }
      }
    }

    .color-4 {
      .right-item-msg {
        i {
          background: #00B2FC;
        }
      }

      .right-item-content {
        span {
          color: #00B2FC;
        }

        label {
          color: #00B2FC;
        }
      }
    }
  }
}



@media screen and (max-width: 1600px) {
  .home-rrisk-mian {

    .home-rrisk-right {
      .rrisk-right-item {

        .right-item-msg {
          i {
            width: 5px;
            height: 5px;
            margin-right: 5px;
          }

          span {
            font-size: 8px;
          }
        }


        .right-item-content {
          margin-top: 10px;

          span {
            font-size: 20px;
          }

          label {
            font-size: 11px;
          }
        }
      }


    }
  }
}
</style>
 
 